const PageType = {
    ArtistDetail: 'artist',
    Cart: 'cart',
    CookiePolicy: 'cookiePolicy',
    Custom: 'pages',
    ExhibitionDetail: 'show',
    Footer: 'footer',
    Header: 'header',
    InventoryDetail: 'inventory',
    InventoryDetailModal: 'inventoryModal',
    PasswordProtection: 'passwordProtection',
    SearchResults: 'search',

    Content: {
        Accordion: 'accordionContent',
        ArtistCell: {
            Grid: 'artistCellGrid',
            List: 'artistCellList',
            ListPreview: 'artistCellListPreview',
            Slideshow: 'artistCellSlideshow',
        },
        ArtistImageParallax: 'artistImageParallax',
        ArtistTab: 'artistTabContent',
        BlogCell: 'blogCell',
        Blog: 'blogContent',
        BlogImageParallax: 'blogImageParallax',
        Button: {
            Primary: 'buttonPrimary',
            Secondary: 'buttonSecondary'
        },
        Cart: {
            InventoryLineItemCell: 'cartInventoryLineItemCell',
            PromoCodeLineItemCell: 'cartPromoCodeLineItemCell'
        },
        ExhibitionCell: {
            Grid: 'showCell',
            Parallax: 'showCellParallax',
            Slideshow: 'showCellSlideshow'
        },
        ExhibitionImageParallax: 'showImageParallax',
        ExhibitionTab: 'showTabContent',
        InventoryCell: {
            Grid: 'inventoryCellGrid',
            Slideshow: 'inventoryCellSlideshow',            // DEPRECATED - use `PageType.Content.InventoryCell.SlideshowV2`
            SlideshowV2: 'inventoryCellSlideshow_v2',
            Waterfall: 'inventoryCellWaterfall'
        },
        InventoryDetailModal: 'inventoryDetailModalOverride',
        InventoryImageParallax: 'inventoryImageParallax',
        Media: 'mediaContent',
        Parallax: 'parallaxContent',
        RecentlyViewedCell: 'recentlyViewedCell',
        RepresentativeCell: 'galleryCell',
        SearchBar: 'searchBar',
        SearchResultCell: {
            Artist: 'artistSearchResultCell',
            Blog: 'blogSearchResultCell',
            Exhibition: 'exhibitionSearchResultCell',
            Inventory: 'inventorySearchResultCell'
        },
        Slide: 'slideContent',
        Tab: 'tabContent'
    },

    Form: {
        ArtistSignup: 'artistSignupForm',
        Cart: {
            Card: 'cartCardForm',
            PromoCode: 'cartPromoCodeForm'
        },
        Contact: 'contactForm',
        FooterSubscribe: 'footerSubscribeForm',
        HeaderSearch: 'headerSearchForm',
        Inquire: 'inquireForm',
        Offer: 'offerForm',
        Password: 'passwordForm',
        Subscribe: 'subscribeForm'
    },

    Popup: {
        Inquire: 'inquirePopup',
        Offer: 'offerPopup',
        Purchase: 'purchasePopup',
        Subscribe: 'subscribePopup'
    }
};
export default PageType;